import { Component, Injectable, OnInit } from "@angular/core";
import { CommonService } from "../service/common.service";
import { OutputService } from "../service/output.service";
import { UsersService } from "../service/users.service";
import { Router } from "@angular/router";
import { MonshinService } from "../service/monshin.service";

@Component({
  selector: "app-kekka-download",
  templateUrl: "./kekka-download.component.html",
  styleUrls: ["./kekka-download.component.css"],
})
export class KekkaDownloadComponent implements OnInit {
  constructor(
    public commonService: CommonService,
    private outputService: OutputService,
    private usersService: UsersService,
    private router: Router,
    private monshinService: MonshinService
  ) {}

  isLoaded: boolean = false;
  datalist: any = [];
  all_count: any = [];

  homeInfoList: any;

  ngOnInit(): void {
    this.getKekkaData();
    window.scrollTo(0, 0);
    this.getHomeInfoList();
  }

  getKekkaData() {
    this.outputService.getKekkaDownloadEvent().subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.all_count = res["fuel_results"]["all_count"];
          this.datalist = res["fuel_results"]["data"];
          this.isLoaded = true;
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }

  getKekkaPdf(row: any): void {
    let param = {
      t_person_id: row.t_person_id,
    };
    this.outputService.downloadKekkaPdf(param);
  }
  /**
   * 1ファイルでのダウンロード処理
   * @param tqc t_question_categoryレコード＋α
   */
  goOutputSingle(tqc): void {
    // 確認ダイアル
    this.commonService.modalOpens(
      53001,
      //ファイルを出力しますか？
      (modalresult) => {
        if (modalresult == "OK") {
          //OK時の処理
          let param = {
            t_event_id: tqc.t_event_id.toString(),
            m_language_id: tqc.m_language_id,
            t_question_category_id: tqc.t_question_category_id.toString(),
            mode: "3",
            person_list: [tqc.t_person_id],
            class_id: tqc.class_id,
            class_nm: tqc.class_nm,
          };

          this.outputService
            .execOutputSingle(param)
            .subscribe((res: Response) => {
              if (res["fuel_status"] == "OK") {
                // download処理
                let downloadParam = {
                  t_output_history_id:
                    res["fuel_results"]["t_output_history_id"],
                };
                this.outputService.downloadFile(downloadParam);
              }
            });
        }
      }
    );
  }
  getHomeInfoList() {
    this.monshinService.getHomeInfoList().subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          //管理者権限なのかの判定 → false=管理者
          if (res["fuel_results"]["role_check"] == false) {
            this.router.navigate(["/admin"]);
          }
          this.homeInfoList = res["fuel_results"]["home_list"];
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(
            res["fuel_message"],
            (modalresult) => {}
          );
        } else {
          this.commonService.modalOpens(11003, (modalresult) => {
            // シボレス、システム双方がsession切れの場合、ログイン画面へ遷移
            // SSO対応しているserverのみ
            var page_url = location.href;
            var ssoAuth = page_url.includes("wellnessSupportToolsSec");
            if (ssoAuth) {
              this.router.navigate(["/signin"]);
            }
          });
        }
      },
      (error) => {
        this.commonService.modalOpens(error, (modalresult) => {});
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/b0104-kekka-download/kekka-download.component.ts